import { useQuery } from '@tanstack/react-query'
import { useAppContext } from '../../../../../../redux/slices/appContext'
import { postNamedQuery } from '../../../../../../service'
import { useSeCodes } from '../seDebug/SeDebugContext'

export default function usePlanStatusReport () {
  const { clientId } = useAppContext()
  const codes = useSeCodes()

  const query = useQuery({
    queryKey: ['invoke-smart-endpoint', codes.list, clientId],
    queryFn: async () => {
      const { data } = await postNamedQuery('coreData', 'invoke-smart-endpoint', {
        pipelineCode: codes.list,
        variables: { clientId }
      })
      return data
    },
    enabled: !!clientId
  })

  const plan = query.data?.data?.[0] ?? null
  const notLinked = query.data?.notLinked === true

  return {
    plan,
    notLinked,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch
  }
}
